const iconMap = {
  pmaIcon: (
    <svg xmlns="http://www.w3.org/2000/svg" width="14" height="13" fill="none">
      <path
        fill="#838383"
        d="M1.583 3.364c0-1.075 0-1.613.357-1.947.357-.334.932-.334 2.08-.334 1.15 0 1.724 0 2.081.334s.357.872.357 1.947v6.272c0 1.075 0 1.613-.357 1.947-.357.334-.931.334-2.08.334-1.15 0-1.724 0-2.08-.334-.358-.334-.358-.872-.358-1.947V3.364Zm5.959 4.978c0-1.124 0-1.686.357-2.035.357-.349.931-.349 2.08-.349 1.15 0 1.724 0 2.08.35.358.348.358.91.358 2.034v1.191c0 1.124 0 1.686-.357 2.035-.357.349-.932.349-2.08.349-1.15 0-1.724 0-2.081-.35-.357-.348-.357-.91-.357-2.034V8.342Zm0-5.362c0-.59 0-.884.092-1.116a1.24 1.24 0 0 1 .66-.684c.224-.097.508-.097 1.076-.097h1.219c.567 0 .851 0 1.075.097.299.128.536.374.66.684.093.232.093.526.093 1.115s0 .883-.093 1.116a1.24 1.24 0 0 1-.66.684c-.224.096-.508.096-1.075.096h-1.22c-.567 0-.851 0-1.075-.096a1.242 1.242 0 0 1-.66-.684c-.092-.233-.092-.527-.092-1.116Z"
      />
    </svg>
  ),
  pacManIcon: (
    <svg xmlns="http://www.w3.org/2000/svg" width="13" height="13" fill="none">
      <path
        fill="#838383"
        d="m7.775 6.5 2.775-2.775c.15-.15.15-.337.037-.488C9.575 1.962 8.114 1.25 6.5 1.25c-2.888 0-5.25 2.362-5.25 5.25 0 2.887 2.362 5.25 5.25 5.25a5.23 5.23 0 0 0 4.088-1.95c.112-.15.112-.375-.038-.488L7.775 6.5ZM5.75 5.75a1.105 1.105 0 0 1-1.125-1.125c0-.638.487-1.125 1.125-1.125s1.125.487 1.125 1.125S6.388 5.75 5.75 5.75Z"
      />
    </svg>
  ),
  notionIcon: (
    <svg xmlns="http://www.w3.org/2000/svg" width="13" height="13" fill="none">
      <g clip-path="url(#a)">
        <path
          fill="#0F0F10"
          fill-rule="evenodd"
          d="M2.643 11.457 1.353 9.85a2.157 2.157 0 0 1-.478-1.351V2.68c0-.733.586-1.341 1.343-1.393L8.2.88a1.95 1.95 0 0 1 1.223.327l2.102 1.42c.376.255.6.67.6 1.115v6.614c0 .717-.576 1.311-1.317 1.357l-6.64.409a1.813 1.813 0 0 1-1.525-.665Z"
          clip-rule="evenodd"
        />
        <path
          fill="#AAA"
          d="M4.718 5.592v-.076c0-.193.155-.353.354-.367l1.452-.097L8.53 8.01V5.414l-.516-.069V5.31c0-.195.158-.357.36-.367l1.32-.068v.19c0 .09-.066.166-.157.181L9.22 5.3v4.202l-.399.138a.774.774 0 0 1-.895-.296L5.977 6.4v2.81l.6.114-.008.056a.376.376 0 0 1-.359.314l-1.492.067a.346.346 0 0 1 .315-.376l.196-.02V5.62l-.511-.029Z"
        />
        <path
          fill="#AAA"
          fill-rule="evenodd"
          d="m8.253 1.613-5.982.408a.671.671 0 0 0-.636.66v5.818c0 .326.113.643.32.9l1.29 1.607c.208.26.536.403.875.382l6.64-.409a.634.634 0 0 0 .605-.623V3.742a.619.619 0 0 0-.276-.512L8.987 1.809a1.17 1.17 0 0 0-.734-.196ZM2.568 2.77c-.083-.061-.044-.19.06-.197l5.665-.406a.78.78 0 0 1 .506.14l1.137.805c.043.03.023.097-.03.1l-6 .326a.779.779 0 0 1-.505-.15l-.833-.618Zm1.057 1.79c0-.194.158-.355.359-.366l6.342-.346c.196-.01.361.14.361.33v5.728a.373.373 0 0 1-.357.367l-6.302.358a.375.375 0 0 1-.403-.366V4.562Z"
          clip-rule="evenodd"
        />
      </g>
      <defs>
        <clipPath id="a">
          <path fill="#fff" d="M.5.5h12v12H.5z" />
        </clipPath>
      </defs>
    </svg>
  ),
  flowChartIcon: (
    <svg xmlns="http://www.w3.org/2000/svg" width="13" height="13" fill="none">
      <path
        fill="#6C6C6C"
        fill-rule="evenodd"
        d="M4.044 1.853a1.8 1.8 0 1 0-2.19 2.191.455.455 0 0 0-.004.056v4.8c0 .019.001.038.003.056a1.8 1.8 0 1 0 2.191 2.19.467.467 0 0 0 .056.004h4.8a.467.467 0 0 0 .056-.003 1.8 1.8 0 1 0 2.19-2.191.467.467 0 0 0 .004-.056V4.1a.467.467 0 0 0-.003-.056 1.8 1.8 0 1 0-2.191-2.19.455.455 0 0 0-.056-.004H4.1a.455.455 0 0 0-.056.003ZM2.747 4.044a.455.455 0 0 1 .003.056v4.8a.455.455 0 0 1-.003.056 1.803 1.803 0 0 1 1.297 1.297.467.467 0 0 1 .056-.003h4.8c.019 0 .038.001.056.003a1.803 1.803 0 0 1 1.297-1.297.467.467 0 0 1-.003-.056V4.1c0-.019.001-.038.003-.056a1.803 1.803 0 0 1-1.297-1.297.455.455 0 0 1-.056.003H4.1a.455.455 0 0 1-.056-.003 1.803 1.803 0 0 1-1.297 1.297Z"
        clip-rule="evenodd"
      />
    </svg>
  ),
  landingPageIcon: (
    <svg xmlns="http://www.w3.org/2000/svg" width="13" height="13" fill="none">
      <path
        fill="#6C6C6C"
        fill-rule="evenodd"
        d="M1.379 1.379C.73 2.027.56 2.966.516 4.55h11.968c-.044-1.584-.214-2.523-.863-3.171C10.743.5 9.328.5 6.5.5c-2.828 0-4.243 0-5.121.879ZM.5 6.5c0-.374 0-.723.002-1.05H4.25v7.024c-1.404-.059-2.265-.247-2.871-.853C.5 10.743.5 9.328.5 6.5Zm2.4-3a.6.6 0 1 0 0-1.2.6.6 0 0 0 0 1.2Zm2.4-.6a.6.6 0 1 1-1.2 0 .6.6 0 0 1 1.2 0Zm1.2.6a.6.6 0 1 0 0-1.2.6.6 0 0 0 0 1.2Z"
        clip-rule="evenodd"
      />
      <path
        fill="#6C6C6C"
        d="M12.5 6.5c0 2.828 0 4.243-.879 5.121-.878.879-2.293.879-5.121.879-.491 0-.94 0-1.35-.005V5.45h7.348c.002.327.002.676.002 1.05Z"
      />
    </svg>
  ),
  mobileAppIcon: (
    <svg xmlns="http://www.w3.org/2000/svg" width="12" height="9" fill="none">
      <path
        fill="#838383"
        d="M7.229.014c.225.06.36.286.299.506l-2.24 8.174a.424.424 0 0 1-.517.292.412.412 0 0 1-.299-.506L6.712.306a.424.424 0 0 1 .517-.292Zm1.274 1.682a.43.43 0 0 1 .597-.03l.98.862c.414.365.758.668.995.942.248.29.425.6.425.983s-.177.694-.425.983c-.236.274-.58.577-.996.943L9.1 7.24a.43.43 0 0 1-.597-.03.407.407 0 0 1 .032-.584l.956-.842c.444-.39.743-.655.937-.88.186-.217.227-.343.227-.451 0-.108-.04-.234-.227-.45-.194-.226-.493-.49-.937-.881l-.956-.842a.407.407 0 0 1-.032-.584Zm-5.038.584a.407.407 0 0 0 .032-.584.43.43 0 0 0-.597-.03l-.98.862c-.414.365-.758.668-.995.942-.248.29-.425.6-.425.983s.177.694.425.983c.237.274.58.577.996.942l.979.862a.43.43 0 0 0 .597-.03.407.407 0 0 0-.032-.584l-.956-.842c-.444-.39-.743-.655-.937-.88-.186-.217-.227-.343-.227-.451 0-.108.04-.234.227-.45.194-.226.493-.49.937-.881l.956-.842Z"
      />
    </svg>
  ),
  claymistIcon: <div className="i:ph-heart" />,
  supabaseIcon: (
    <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g clip-path="url(#clip0_469_3622)">
        <path
          d="M9.3135 15.734C8.90512 16.2486 8.0755 15.9667 8.06637 15.3094L7.92188 5.69611H14.3863C15.5569 5.69611 16.2096 7.04823 15.4816 7.96473L9.3135 15.734Z"
          fill="url(#paint0_linear_469_3622)"
        />
        <path
          d="M9.3135 15.734C8.90512 16.2486 8.0755 15.9667 8.06637 15.3094L7.92188 5.69611H14.3863C15.5569 5.69611 16.2096 7.04823 15.4816 7.96473L9.3135 15.734Z"
          fill="url(#paint1_linear_469_3622)"
          fill-opacity="0.2"
        />
        <path
          d="M6.68515 0.265999C7.09352 -0.248626 7.92327 0.0332487 7.93227 0.690499L7.99577 10.3039H1.6124C0.441774 10.3039 -0.210976 8.95175 0.516899 8.03525L6.68515 0.265999Z"
          fill="#3ECF8E"
        />
      </g>
      <defs>
        <linearGradient
          id="paint0_linear_469_3622"
          x1="7.92246"
          y1="7.82826"
          x2="13.6675"
          y2="10.2377"
          gradientUnits="userSpaceOnUse"
        >
          <stop stop-color="#249361" />
          <stop offset="1" stop-color="#3ECF8E" />
        </linearGradient>
        <linearGradient
          id="paint1_linear_469_3622"
          x1="5.37538"
          y1="4.34086"
          x2="7.99536"
          y2="9.27306"
          gradientUnits="userSpaceOnUse"
        >
          <stop />
          <stop offset="1" stop-opacity="0" />
        </linearGradient>
        <clipPath id="clip0_469_3622">
          <rect width="16" height="16" fill="white" />
        </clipPath>
      </defs>
    </svg>
  ),
  githubIcon: (
    <svg width="16" height="16" viewBox="0 0 13 12" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M6.14896 0C5.34147 0 4.54188 0.159048 3.79586 0.468062C3.04983 0.777076 2.37197 1.23001 1.80099 1.80099C0.647835 2.95414 0 4.51816 0 6.14896C0 8.8668 1.76475 11.1727 4.20589 11.9905C4.51334 12.0397 4.61172 11.849 4.61172 11.683V10.6439C2.90846 11.0128 2.54567 9.81989 2.54567 9.81989C2.26282 9.10661 1.86314 8.91599 1.86314 8.91599C1.30358 8.53476 1.90618 8.54706 1.90618 8.54706C2.52107 8.5901 2.84697 9.1804 2.84697 9.1804C3.38193 10.115 4.28583 9.83834 4.63632 9.69076C4.69166 9.29108 4.85153 9.02053 5.0237 8.8668C3.65863 8.71308 2.22592 8.18427 2.22592 5.84151C2.22592 5.15898 2.45958 4.61172 2.85927 4.17515C2.79778 4.02142 2.58256 3.38193 2.92076 2.55182C2.92076 2.55182 3.43727 2.3858 4.61172 3.17901C5.09749 3.04374 5.6263 2.9761 6.14896 2.9761C6.67162 2.9761 7.20043 3.04374 7.6862 3.17901C8.86065 2.3858 9.37717 2.55182 9.37717 2.55182C9.71536 3.38193 9.50015 4.02142 9.43866 4.17515C9.83834 4.61172 10.072 5.15898 10.072 5.84151C10.072 8.19042 8.63314 8.70693 7.26192 8.86065C7.48329 9.05127 7.6862 9.42636 7.6862 9.99821V11.683C7.6862 11.849 7.78459 12.0458 8.09818 11.9905C10.5393 11.1665 12.2979 8.8668 12.2979 6.14896C12.2979 5.34147 12.1389 4.54188 11.8299 3.79586C11.5208 3.04983 11.0679 2.37197 10.4969 1.80099C9.92595 1.23001 9.24809 0.777076 8.50207 0.468062C7.75604 0.159048 6.95645 0 6.14896 0Z"
        fill="currentColor"
      />
    </svg>
  ),
  rocket: (
    <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M11.6267 10.7756L15.399 7.01467C15.9422 6.47304 16.2138 6.20222 16.3569 5.85785C16.5 5.51347 16.5 5.13049 16.5 4.36453V3.99859C16.5 2.82075 16.5 2.23182 16.133 1.86591C15.766 1.5 15.1753 1.5 13.9939 1.5H13.6268C12.8585 1.5 12.4744 1.5 12.129 1.64265C11.7836 1.78529 11.5119 2.0561 10.9687 2.59773L7.19642 6.35863C6.56162 6.99151 6.168 7.38394 6.01558 7.76297C5.96742 7.88273 5.94334 8.00115 5.94334 8.1254C5.94334 8.64288 6.36103 9.05931 7.19642 9.89217L7.30869 10.0041L8.6239 8.6693C8.81146 8.47894 9.11783 8.47668 9.30819 8.66424C9.49856 8.8518 9.50082 9.15817 9.31326 9.34852L7.99404 10.6874L8.08247 10.7756C8.91785 11.6084 9.33554 12.0249 9.85458 12.0249C9.96927 12.0249 10.079 12.0045 10.1894 11.9639C10.5786 11.8205 10.9759 11.4244 11.6267 10.7756ZM13.3989 6.3589C12.9095 6.84678 12.1161 6.84678 11.6268 6.3589C11.1374 5.87102 11.1374 5.08001 11.6268 4.59213C12.1161 4.10425 12.9095 4.10425 13.3989 4.59213C13.8882 5.08001 13.8882 5.87102 13.3989 6.3589Z"
        fill="#8DD290"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M2.08056 9.36104C2.30275 9.58349 2.30253 9.94393 2.08007 10.1661L1.96334 10.2827C1.86363 10.3823 1.86363 10.5435 1.96334 10.6431C2.06344 10.743 2.22601 10.743 2.32611 10.6431L3.6102 9.36055C3.83265 9.13837 4.1931 9.13859 4.41528 9.36104C4.63746 9.58349 4.63724 9.94393 4.41479 10.1661L3.1307 11.4486C2.58608 11.9926 1.70337 11.9926 1.15875 11.4486C0.61375 10.9043 0.61375 10.0215 1.15875 9.47714L1.27549 9.36055C1.49794 9.13837 1.85838 9.13859 2.08056 9.36104ZM5.47289 12.522C5.69272 12.7467 5.68871 13.1072 5.46394 13.327L4.16631 14.596C3.94153 14.8159 3.58111 14.8119 3.36128 14.5871C3.14145 14.3623 3.14546 14.0019 3.37024 13.7821L4.66786 12.513C4.89264 12.2932 5.25307 12.2972 5.47289 12.522ZM8.61084 13.5885C8.83302 13.811 8.8328 14.1714 8.61035 14.3936L7.32626 15.6761C7.22654 15.7757 7.22654 15.9369 7.32626 16.0365C7.42635 16.1365 7.58893 16.1365 7.68902 16.0365L7.80576 15.9199C8.02821 15.6977 8.38866 15.6979 8.61084 15.9204C8.83302 16.1428 8.8328 16.5033 8.61035 16.7254L8.49361 16.842C7.94899 17.386 7.06628 17.386 6.52167 16.842C5.97667 16.2977 5.97667 15.4149 6.52167 14.8706L7.80576 13.588C8.02821 13.3659 8.38866 13.3661 8.61084 13.5885Z"
        fill="#8DD290"
      />
      <g opacity="0.5">
        <path
          d="M8.13505 4.05694L6.49426 5.69278C6.19267 5.99345 5.91601 6.26926 5.69753 6.51859C5.55723 6.67871 5.41702 6.85395 5.29825 7.0476L5.28226 7.03166C5.25192 7.0014 5.23672 6.98626 5.22149 6.97147C4.9363 6.69476 4.60084 6.47476 4.23306 6.32323C4.2134 6.31513 4.19345 6.30723 4.15356 6.29142L3.90926 6.19462C3.57831 6.06348 3.49011 5.63744 3.74194 5.38638C4.46467 4.66584 5.33241 3.80074 5.75119 3.62698C6.12052 3.47374 6.51948 3.42276 6.90427 3.47962C7.25684 3.53172 7.59037 3.71282 8.13505 4.05694Z"
          fill="#8DD290"
        />
        <path
          d="M10.9367 12.67C11.0689 12.8042 11.1567 12.899 11.2361 13.0003C11.3408 13.1339 11.4345 13.2759 11.5161 13.4247C11.608 13.5923 11.6793 13.7712 11.822 14.1292C11.9382 14.4206 12.3241 14.4976 12.5482 14.2741L12.6025 14.2201C13.3252 13.4995 14.1929 12.6344 14.3672 12.2169C14.5209 11.8486 14.572 11.4509 14.515 11.0672C14.4627 10.7158 14.2811 10.3833 13.936 9.8404L12.2898 11.4817C11.9814 11.7892 11.6986 12.0712 11.4428 12.2921C11.2895 12.4244 11.1218 12.5567 10.9367 12.67Z"
          fill="#8DD290"
        />
      </g>
      <g opacity="0.5">
        <path
          d="M5.76515 10.9225C5.98746 10.7002 5.98746 10.3397 5.76515 10.1174C5.54283 9.89511 5.18238 9.89511 4.96007 10.1174L3.35326 11.7242C3.13094 11.9465 3.13094 12.307 3.35326 12.5293C3.57558 12.7516 3.93602 12.7516 4.15834 12.5293L5.76515 10.9225Z"
          fill="#8DD290"
        />
        <path
          d="M7.87201 13.0268C8.09433 12.8045 8.09433 12.444 7.87201 12.2217C7.64969 11.9994 7.28925 11.9994 7.06693 12.2217L5.47111 13.8175C5.2488 14.0398 5.2488 14.4003 5.47111 14.6226C5.69343 14.8449 6.05388 14.8449 6.27619 14.6226L7.87201 13.0268Z"
          fill="#8DD290"
        />
      </g>
    </svg>
  ),
  refresh: (
    <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M10.8623 0.861949C11.1226 0.6016 11.5447 0.6016 11.8051 0.861949L14.4717 3.52862C14.7321 3.78897 14.7321 4.21108 14.4717 4.47142L11.8051 7.13809C11.5447 7.39844 11.1226 7.39844 10.8623 7.13809C10.6019 6.87774 10.6019 6.45563 10.8623 6.19528L13.0575 4.00002L10.8623 1.80476C10.6019 1.54441 10.6019 1.1223 10.8623 0.861949Z"
        fill="#FDFDFD"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M4.66634 4.66665C4.13591 4.66665 3.6272 4.87736 3.25213 5.25243C2.87705 5.62751 2.66634 6.13621 2.66634 6.66665V7.33331C2.66634 7.7015 2.36786 7.99998 1.99967 7.99998C1.63148 7.99998 1.33301 7.7015 1.33301 7.33331V6.66665C1.33301 5.78259 1.6842 4.93474 2.30932 4.30962C2.93444 3.6845 3.78229 3.33331 4.66634 3.33331H13.9997C14.3679 3.33331 14.6663 3.63179 14.6663 3.99998C14.6663 4.36817 14.3679 4.66665 13.9997 4.66665H4.66634Z"
        fill="#FDFDFD"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M5.13775 8.86195C5.3981 9.1223 5.3981 9.54441 5.13775 9.80476L2.94248 12L5.13775 14.1953C5.3981 14.4556 5.3981 14.8777 5.13775 15.1381C4.8774 15.3984 4.45529 15.3984 4.19494 15.1381L1.52827 12.4714C1.26792 12.2111 1.26792 11.789 1.52827 11.5286L4.19494 8.86195C4.45529 8.6016 4.8774 8.6016 5.13775 8.86195Z"
        fill="#FDFDFD"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M13.9997 8C14.3679 8 14.6663 8.29848 14.6663 8.66667V9.33333C14.6663 10.2174 14.3151 11.0652 13.69 11.6904C13.0649 12.3155 12.2171 12.6667 11.333 12.6667H1.99967C1.63148 12.6667 1.33301 12.3682 1.33301 12C1.33301 11.6318 1.63148 11.3333 1.99967 11.3333H11.333C11.8634 11.3333 12.3721 11.1226 12.7472 10.7475C13.1223 10.3725 13.333 9.86377 13.333 9.33333V8.66667C13.333 8.29848 13.6315 8 13.9997 8Z"
        fill="#FDFDFD"
      />
    </svg>
  ),
};

export default iconMap;
